'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _magicVirtualElement = require('magic-virtual-element');

var _magicVirtualElement2 = _interopRequireDefault(_magicVirtualElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
	class: {
		type: 'string'
	},
	family: {
		type: 'string'
	},
	onClick: {
		type: 'function'
	},
	size: {
		type: 'string'
	},
	icon: {
		type: 'string'
	}
}; /** @jsx dom */


var defaultProps = {
	family: 'fal'
};

var render = function render(_ref) {
	var props = _ref.props;
	var family = props.family,
	    icon = props.icon,
	    onClick = props.onClick,
	    size = props.size;

	var styles = {
		fontSize: size
	};

	return (0, _magicVirtualElement2.default)(
		'div',
		{ 'class': ['SCMS-Icon', props.class], style: styles, onClick: onClick },
		(0, _magicVirtualElement2.default)('i', { 'class': family + ' fa-' + icon })
	);
};

exports.default = { defaultProps: defaultProps, propTypes: propTypes, render: render };
